
<div class="card mb-4">
    <div class="card-header">
        <h3>Routing de Productos de Compras</h3>
    </div>

    <div class="card-body">
        <div class="row mb-3">

            <!-- PRODUCTO COMPRA -->
            <div class="col-md-6">
                <h6>Producto Compra</h6>

                <app-input-autocomplete
                    [allBorderRadius]="true"
                    [inputs]="inputs.productPurchase"
                    [placeholder]="'Ingresa un producto de compra'"
                    [filterElements]="filterProductsPurchase"
                    [typeElements]="'product-order'"
                    (inputMethod)="writeProductPurchase($event.event)"
                    (changeStatus)="checkProductPurchase($event.filterElement)"
                    (getTitle)="
                        $event.filterElement.title =
                        $event.filterElement.code + ' - ' +
                        $event.filterElement.name
                    ">
                </app-input-autocomplete>
            </div>

            <!-- PRODUCTO OC -->
            <div class="col-md-6">
                <h6>Producto OC</h6>

                <app-input-autocomplete
                    [allBorderRadius]="true"
                    [inputs]="inputs.productOC"
                    [placeholder]="'Ingresa un producto OC'"
                    [filterElements]="filterProductsOC"
                    [typeElements]="'product-order'"
                    (inputMethod)="writeProductOC($event.event)"
                    (changeStatus)="checkProductOC($event.filterElement)"
                    (getTitle)="
                        $event.filterElement.title =
                        $event.filterElement.code + ' - ' +
                        $event.filterElement.name
                    ">
                </app-input-autocomplete>
            </div>

        </div>

        <div class="d-flex justify-content-end gap-2 mt-3">

            <button
                class="btn btn-outline-secondary"
                [disabled]="saving"
                (click)="reset()">
                Limpiar
            </button>

            <button
                class="btn btn-success"
                [disabled]="
                    saving ||
                    !inputs.productPurchase.verified ||
                    !inputs.productOC.verified ||
                    !inputs.productPurchase.data?.id ||
                    !inputs.productOC.data?.id
                "
                (click)="saveRouting()">

                <i
                    *ngIf="saving"
                    class="fa fa-spinner fa-spin me-1">
                </i>

                {{ saving ? 'Guardando...' : 'Guardar Routing' }}
            </button>

        </div>
    </div>
</div>


<!-- TABLA DE ASIGNACIONES -->
<div class="card">

    <div class="card-header">
        <h3>Routing Asignaciones de Compras</h3>
    </div>

    <div class="card-body">

        <div class="row mb-3">

            <div
                class="table-responsive"
                style="margin-bottom: 0; overflow-y: inherit; max-height: none;">

                <table
                    class="table table-striped"
                    style="margin-bottom: 0; margin-top: 10px;">

                    <thead>
                        <tr class="tr-middle">

                            <th class="ta bg-info-subtle">
                                Código Compra
                            </th>

                            <th class="ta bg-info-subtle">
                                Producto Compra
                            </th>

                            <th class="ta">
                                Código OC
                            </th>

                            <th class="ta">
                                Producto OC
                            </th>

                            <th class="ta">
                                Acción
                            </th>

                        </tr>
                    </thead>

                    <tbody>

                        <tr
                            class="tr-middle"
                            *ngFor="let routing of routingProductPurchaseList">

                            <!-- CÓDIGO COMPRA -->
                            <td class="col bg-info-subtle">
                                {{ routing.productPurchaseData?.code }}
                            </td>

                            <!-- PRODUCTO COMPRA -->
                            <td class="col bg-info-subtle">
                                {{ routing.productPurchaseData?.name }}
                            </td>

                            <!-- CÓDIGO OC -->
                            <td class="col">
                                {{ routing.productOCData?.code }}
                            </td>

                            <!-- PRODUCTO OC -->
                            <td class="col">
                                {{ routing.productOCData?.name }}
                            </td>

                            <!-- ACCIONES -->
                            <td class="col">

                                <span
                                    class="clickeable text-danger a-hover"
                                    [class.disabled]="deleting[routing.id]"
                                    (click)="deleteRouting(routing.id)">

                                    <i
                                        *ngIf="!deleting[routing.id]"
                                        class="fa fa-trash">
                                    </i>

                                    <i
                                        *ngIf="deleting[routing.id]"
                                        class="fa fa-spinner fa-spin">
                                    </i>

                                </span>

                            </td>

                        </tr>

                        <tr *ngIf="routingProductPurchaseList.length === 0">
                            <td colspan="5" class="text-center text-muted py-3">
                                No hay routings de compras registrados.
                            </td>
                        </tr>

                    </tbody>
                </table>

            </div>
        </div>
    </div>
</div>
